// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "23dadc9-dirty",
    "hash": "23dadc9",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "23dadc9-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
